import LegalDocumentLayout from "./LegalDocumentLayout";
import LegalPageWithOverride from "./LegalPageWithOverride";
import SeoHead from "@/components/SeoHead";

export default function TermsPage() {
  return (
    <>
      <SeoHead route="/terms" />
      <LegalPageWithOverride
        slug="terms"
        title="Terms of Service"
        lastUpdatedFallback="October 7, 2026"
      >
      <LegalDocumentLayout title="Terms of Service" lastUpdated="October 7, 2026">
      <p>
        These Terms of Service ("Terms") govern your use of Acquigine. By creating an account or using the service you agree to these Terms.
        This page is provided for transparency and does not constitute legal advice.
      </p>

      <h2>1. What Acquigine Is</h2>
      <p>
        Acquigine is a <strong>technology platform</strong> that provides data intelligence, discovery, scoring, workflow, document-generation, and outreach tooling for professionals evaluating potential acquisitions of businesses, multifamily properties, and land.
      </p>
      <p>
        <strong>What Acquigine is not:</strong>
      </p>
      <ul>
        <li>Acquigine is <strong>not a broker</strong>, does not represent buyers or sellers, and does not receive commissions on deals.</li>
        <li>Acquigine does <strong>not negotiate</strong> on behalf of users. All communications originate from and are the responsibility of the sending user.</li>
        <li>Nothing on the platform ,  including scores, rationales, generated documents, or AI outputs ,  constitutes <strong>legal, tax, accounting, real-estate brokerage, or investment advice</strong>. Consult qualified professionals before acting on any information.</li>
      </ul>

      <h2>2. Accounts</h2>
      <p>
        You are responsible for maintaining the confidentiality of your credentials and for all activity under your account. You must be at least 18 years old and legally able to enter this agreement.
      </p>

      <h2>3. Subscription, Billing, and Cancellation</h2>
      <ul>
        <li>Free tier includes 5 saved opportunities per month with scoring visible.</li>
        <li>Paid tiers (Pro $99/mo, Business $299/mo) are billed monthly or annually via our payment processing provider. Prices are stated in USD, exclusive of applicable taxes.</li>
        <li>You may cancel at any time from your billing settings. Cancellation takes effect at the end of the current billing period; you retain access until then.</li>
        <li>All fees are non-refundable except where required by law.</li>
      </ul>

      <h2>4. Acceptable Use</h2>
      <ul>
        <li>You will comply with all applicable laws, including <strong>CAN-SPAM</strong>, <strong>TCPA</strong>, state Do-Not-Call registries, and any other outreach or telemarketing regulations that apply to your jurisdiction.</li>
        <li>When you send email through Acquigine using your connected email or e-signature accounts, <strong>you are the sender</strong>. You are responsible for consent, disclosures, opt-outs, and content.</li>
        <li>You will not use the platform to send unlawful, deceptive, or harassing communications.</li>
        <li>You will not attempt to reverse-engineer, resell, or bulk-export our proprietary scoring outputs, discovery logic, or data-source integrations.</li>
      </ul>

      <h2>5. Data Accuracy Disclaimer</h2>
      <p>
        Acquigine aggregates data from public records and licensed third-party APIs. <strong>Public records may be outdated, incomplete, or incorrect.</strong> Third-party enrichment providers make no guarantee of accuracy. You must independently verify any material fact ,  ownership, valuation, distress signals, contact information, or entity status ,  before contacting a party or making a business decision.
      </p>

      <h2>6. Document Templates</h2>
      <p>
        LOI, PSA, marketing, and negotiation templates provided in the platform are <strong>informational examples, not legal documents</strong>. State-specific templates approximate common practice but do not replace attorney review. You are responsible for having any executed document reviewed by qualified counsel in the relevant jurisdiction.
      </p>

      <h2>7. Fair Housing and FCRA</h2>
      <p>
        Acquigine's scoring engine <strong>blocks the use of protected-class variables</strong> (race, national origin, familial status, disability, and other categories under the Fair Housing Act). Data provided by Acquigine <strong>is not a consumer report</strong> and may not be used to determine eligibility for credit, employment, insurance, housing, or any purpose covered by the Fair Credit Reporting Act (FCRA).
      </p>

      <h2>8. Third-Party Integrations</h2>
      <p>
        When you connect third-party email, e-signature, social publishing, or data-enrichment services, your use of those services is also governed by their own terms and privacy policies. Acquigine is not responsible for outages, billing, or content changes on third-party services.
      </p>

      <h2>9. Intellectual Property</h2>
      <p>
        You retain ownership of the content you create in Acquigine (notes, uploaded opportunities, documents). You grant Acquigine a limited license to process this content to provide the service. Acquigine, the logo, and all platform code, scoring models, and design are the intellectual property of Acquigine.
      </p>

      <h2>10. Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, Acquigine and its officers, employees, and affiliates are not liable for any indirect, incidental, consequential, or punitive damages, or for lost profits, lost data, or lost business opportunity, arising from your use of the service. Our aggregate liability shall not exceed the amount you paid to Acquigine in the twelve months preceding the claim.
      </p>

      <h2>11. Warranty Disclaimer</h2>
      <p>
        The service is provided <strong>"as is"</strong> and <strong>"as available"</strong> without warranties of any kind, express or implied, including merchantability, fitness for a particular purpose, or non-infringement.
      </p>

      <h2>12. Indemnification</h2>
      <p>
        You agree to defend and indemnify Acquigine against any claim arising from your outreach content, your use of third-party data, your breach of these Terms, or your violation of law.
      </p>

      <h2>13. Termination</h2>
      <p>
        We may suspend or terminate your account for material breach of these Terms, including unlawful outreach or attempts to bypass the platform's discovery and scoring safeguards.
      </p>

      <h2>14. Governing Law</h2>
      <p>
        These Terms are governed by the laws of the State of Florida, without regard to conflicts of law. Any dispute shall be resolved in the state or federal courts located in Florida, and you consent to that jurisdiction.
      </p>

      <h2>15. Changes to These Terms</h2>
      <p>
        We may update these Terms; material changes will be posted here with a new "Last updated" date and, where practical, communicated by email.
      </p>

      <h2>16. Contact</h2>
      <p>
        Legal: <a href="mailto:legal@acquigine.com">legal@acquigine.com</a><br />
        Compliance: <a href="mailto:compliance@acquigine.com">compliance@acquigine.com</a>
      </p>
    </LegalDocumentLayout>
      </LegalPageWithOverride>
    </>
  );
}
